import { Component, EventEmitter, Output, OnInit } from '@angular/core';
import { ComponentsService } from '../../components.service';
import * as moment from 'moment-timezone';
import { ErrorStateMatcher } from '@angular/material/core';
import { FormControl, FormGroupDirective, NgForm } from '@angular/forms';

/**
 * Workaround za validaciju date picker-a
 */
export class NoErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(
        control: FormControl | null,
        form: FormGroupDirective | NgForm | null
    ): boolean {
        return false;
    }
}

export interface SearchFilters {
    dateFrom: string | null;
    dateTo: string | null;
    status: string;
    userUuid: string;
    ticketUuid: string;
}

@Component({
    selector: 'app-ticket-search-panel',
    templateUrl: './ticket-search-panel.component.html',
    styleUrls: ['./ticket-search-panel.component.scss']
})
export class TicketSearchPanelComponent implements OnInit {
    @Output() search = new EventEmitter<SearchFilters>();
    @Output() clear = new EventEmitter<void>();

    searchFilters: SearchFilters = {
        dateFrom: null,
        dateTo: null,
        status: '',
        userUuid: '',
        ticketUuid: ''
    };

    noErrorMatcher = new NoErrorStateMatcher();

    constructor(private componentsService: ComponentsService) {}

    onSearch() {
        // Format dates for API request
        const formattedFilters: SearchFilters = {
            dateFrom: this.formatDateForApi(this.searchFilters.dateFrom),
            dateTo: this.formatDateForApi(this.searchFilters.dateTo),
            status: this.searchFilters.status,
            userUuid: this.searchFilters.userUuid,
            ticketUuid: this.searchFilters.ticketUuid
        };

        this.search.emit(formattedFilters);
    }

    onClear() {
        // Reset to default date range (start of current month to today) - MATCH tiket component
        const now = new Date();
        const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);

        this.searchFilters = {
            dateFrom: startOfMonth.toString(),
            dateTo: now.toString(),
            status: '',
            userUuid: this.componentsService.info.superAdmin
                ? ''
                : this.componentsService.info.user_id,
            ticketUuid: ''
        };
        this.clear.emit();
    }

    ngOnInit(): void {
        // Set default date range to start of current month
        const now = new Date();
        const startOfMonth = new Date(
            now.getFullYear(),
            now.getMonth(),
            1
        ).toString();

        this.searchFilters.dateFrom = startOfMonth;
        this.searchFilters.dateTo = now.toString();

        // Set userUuid to the logged-in user's ID
        this.searchFilters.userUuid = this.componentsService.info.superAdmin
            ? ''
            : this.componentsService.info.user_id;

        // Emit the default search to load data automatically
        setTimeout(() => {
            this.onSearch(); // Use onSearch to format dates properly
        }, 100);
    }

    // Format date for API requests (YYYY-MM-DD format)
    private formatDateForApi(date: string | null): string | null {
        if (!date || date === '') return null;
        try {
            return moment(date).format('YYYY-MM-DD');
        } catch (error) {
            console.warn('Invalid date format:', error);
            return null;
        }
    }

    // Format date for display (DD/MM/YYYY format)
    formatDateForDisplay(date: string | null): string {
        if (!date) return '';
        try {
            return moment(date).format('DD/MM/YYYY');
        } catch (error) {
            console.warn('Invalid date format:', error);
            return '';
        }
    }
}
